function clickDesktopAccordion(accordionId) {
  const accordionDetails = document.querySelectorAll('.details');
  const accordionCanvas = document.querySelectorAll('.image-accordion-canvas');
  const headerHeight = document.querySelector('header.header')?.clientHeight || 0;

  accordionCanvas.forEach(canvas => canvas.classList.toggle('hidden', canvas.dataset.accordionCanvasId !== accordionId));

  accordionDetails.forEach(details => {
    if (details.open && details.dataset.accordionId !== accordionId) {
      details.open = false;
    }
  });

  const currentDetails = Array.from(accordionDetails).find(details => details.dataset.accordionId === accordionId);
  const stickyElement = document.querySelector('.accordion-images');

  if (stickyElement && currentDetails) {
    setTimeout(() => {
      const stickyTop = stickyElement.getBoundingClientRect().top + window.scrollY;
      const targetScrollY = stickyTop - headerHeight - 25;
      const currentScrollY = window.scrollY;

      if (Math.abs(currentScrollY - targetScrollY) > 5) {
        window.scrollTo({
          top: targetScrollY,
          behavior: 'smooth',
        });
      }
    }, 250);
  }
}

function clickMobileAccordion(accordionId) {
  const contents = document.querySelectorAll('.mobile-accordion-content');
  contents.forEach(content => content.classList.toggle('active', content.dataset.accordionId === accordionId));

  const accordionNames = document.querySelectorAll('.mobile-accordion-element');
  let activeElement = null;
  accordionNames.forEach(name => {
    const isActive = name.dataset.accordionId === accordionId;
    name.classList.toggle('active', isActive);
    if (isActive) {
      activeElement = name;
    }
  });

  const accordionCanvas = document.querySelectorAll('.image-accordion-canvas');
  accordionCanvas.forEach(canvas => canvas.classList.toggle('hidden', canvas.dataset.accordionCanvasId !== accordionId));

  if (activeElement) {
    const container = activeElement.closest('.mobile-accordion');
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const elementRect = activeElement.getBoundingClientRect();

      const isFullyVisible = elementRect.left >= containerRect.left && elementRect.right <= containerRect.right;

      if (!isFullyVisible) {
        const scrollLeft = activeElement.offsetLeft - container.clientWidth / 2 + activeElement.clientWidth / 2;
        const currentScrollLeft = container.scrollLeft;

        if (Math.abs(currentScrollLeft - scrollLeft) > 5) {
          container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }
    }
  }
}
